import { TitleCasePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  input,
  signal, effect,
} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router, RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { authLogout } from '../../core/auth/auth.actions';
import { AuthLoginState } from '../../core/auth/auth.models';
import { UserDTO } from '../../domain/user/user.model';
import { openDialog } from '../dialog/dn-dialog.actions';
import { logo, navigation, navigationSideMenu } from '../navigation/navigation.model';
import { SigninDialogComponent } from './../dialog/signin-dialog/signin-dialog.component';
import { Topic } from '../../domain/topic/topic.model';
import { TranslatePipe } from '@ngx-translate/core';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { FormsModule } from '@angular/forms';
import { MatError, MatFormField, MatInput, MatLabel, MatSuffix } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatAnchor, MatButton, MatIconButton } from '@angular/material/button';
import { MatToolbar } from '@angular/material/toolbar';

interface MenuItem {
  label: string;
  action: Function;
  routerLink: string;
  logoutIcon?: boolean;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'dottnet-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  imports: [
    RouterLink,
    FormsModule,
    TitleCasePipe,
    MatAnchor,
    MatMenuItem,
    MatMenu,
    MatIcon,
    MatMenuTrigger,
    MatButton,
    MatError,
    MatIconButton,
    MatSuffix,
    MatInput,
    MatLabel,
    MatFormField,
    MatToolbar,
    TranslatePipe,
  ],
})
export class ToolbarComponent implements OnInit {
  NOT_LOGGED_MENU_ITEMS: MenuItem[] = [
    {
      label: 'dottnet.menu.login',
      action: this.openSignin,
      routerLink: undefined,
    },
    {
      label: 'dottnet.menu.signup',
      action: undefined,
      routerLink: '/signup',
    },
    {
      label: 'dottnet.menu.managelog',
      action: undefined,
      routerLink: '/log',
    },
  ];

  LOGGED_MENU_ITEMS: MenuItem[] = [
    {
      label: 'dottnet.menu.profile',
      action: this.openSignin,
      routerLink: 'profile/edit',
    },
    {
      label: 'dottnet.menu.managelog',
      action: undefined,
      routerLink: '/log',
    },
    {
      label: 'dottnet.menu.logout',
      action: this.onLogoutClick,
      routerLink: undefined,
      logoutIcon: true,
    },
  ];

  // Input variables
  // Reference to the outer sidenav template reference
  readonly sidenav = input<MatSidenav>(undefined);
  // Reference to the search field
  readonly searchText = input<string>(undefined);
  searchTextInternal = signal(this.searchText);
  // Values from app observables
  readonly authLoginState = input<AuthLoginState>(undefined);
  readonly user = input<UserDTO>(undefined);
  readonly topic = input<Topic>(undefined);

  // References for enums
  readonly AuthLoginState = AuthLoginState;

  // Constants
  navigation: any;
  navigationSideMenu: any;
  logo: string;

  userMenuItems: MenuItem[] = [];

  // Observables solo per debuggare
  // sessionID$: Observable<number>;
  // loginType$: Observable<string>;


  constructor(
    private store: Store,
    private route: Router,
  )
  {
    effect(() => {
      const userChange = this.user();

      if(!userChange || userChange.idAnagrafica === -1){
        this.userMenuItems = this.NOT_LOGGED_MENU_ITEMS;
      }else {
        this.userMenuItems = this.LOGGED_MENU_ITEMS;
      }
    });
  }

  ngOnInit(): void {
    this.navigation = navigation;
    this.navigationSideMenu = navigationSideMenu;
    this.logo = logo;

    //Solo per Debuggare
    // this.sessionID$ = this.store.select(selectSessionID);
    // this.loginType$ = this.store.select(selectGetLoginTypeString);

  }

  openSignin() {
    this.store.dispatch(
      openDialog({
        content: undefined,
        urlToDownload: undefined,
        urlWithContext: undefined,
        componentType: SigninDialogComponent,
        panelClass: 'dn-dialog-small',
      })
    );
  }

  doAction(item: MenuItem) {
    if (item.action) {
      item.action.apply(this);
    }
  }

  onLogoutClick() {
    this.store.dispatch(authLogout());
  }

  searchTextResult() {
    if (this.checkMinLength()) {
      this.route.navigate(['/ricerca', this.searchTextInternal()]);
    }
  }

  checkMinLength(): boolean {
    return this.searchTextInternal()?.length >= 3;
  }

  getUserName(): string {
    const user = this.user();
    if (!(user?.nome + user?.cognome) || user?.nome === 'Guest') return 'Accedi a DottNet';
    return `${user?.nome} ${user?.cognome}`;
  }
}
